import moment from 'moment';
const getDatesQueryString = (currentSearchQuery) => {
    var _a, _b, _c, _d;
    const dates = ((_a = currentSearchQuery.dates) === null || _a === void 0 ? void 0 : _a.startDate) && ((_b = currentSearchQuery.dates) === null || _b === void 0 ? void 0 : _b.endDate)
        ? `${moment((_c = currentSearchQuery.dates) === null || _c === void 0 ? void 0 : _c.startDate).format('YYYY-MM-DD')},${moment((_d = currentSearchQuery.dates) === null || _d === void 0 ? void 0 : _d.endDate).format('YYYY-MM-DD')}`
        : undefined;
    return { dates };
};
export default getDatesQueryString;
